import { FRAMEWORKS } from "./frameworks/_registry";
import type { RegisteredFramework } from "./types";

// Serializable snapshot of the framework-mapping registry, editable live via
// the /admin "Taxonomy Mappings" tab. RegisteredFramework is already plain data
// (definition + entries + mapping lines, no functions), so the static registry
// doubles as the seed. Runtime precedence follows the usual content layering
// (seed ⊕ baseline ⊕ override) in content/resolve.ts.
export type MappingsContent = { frameworks: RegisteredFramework[] };

export const mappingsContent: MappingsContent = {
  frameworks: FRAMEWORKS.map((f) => f),
};
